export default __webpack_public_path__ + "images/SpeakersPhotos/Javier_Martinez.jpg?04867a8d";